import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcClose16Icon, IcPinMenuIcon } from '@gem/icons';
import { IconButton, IconViewSizes } from '@gem/ui-kit';

import { MiniatureMessage } from 'APP/main/ChatView/components/MiniatureMessage/MiniatureMessage';

import { useMessagePinPresenter } from './MessagePin.presenter';
import styles from './MessagePin.styles.m.css';
import { MessagePinTitle } from './MessagePinTitle/MessagePinTitle';

export const MessagePin: FC = observer(() => {
  const presenter = useMessagePinPresenter();

  if (!presenter.pinMessages?.length) {
    return null;
  }

  return (
    <div className={styles.container}>
      <MiniatureMessage
        message={presenter.currentPinnedMessage}
        title={
          <MessagePinTitle
            pinMessagesCount={presenter.pinMessages.length}
            currentMessageIndex={presenter.currentMessageIndex}
          />
        }
        titleClassName={styles.miniatureTitle}
        textClassName={styles.miniatureText}
        iconClassName={styles.miniatureIcon}
        onClick={presenter.onClick}
      />
      {presenter.isShowSingleMessageUnpin && (
        <IconButton
          Icon={IcClose16Icon}
          size={IconViewSizes.Small}
          onClick={presenter.unpin}
          iconClassName={styles.remove}
        />
      )}
      {presenter.pinMessages.length > 1 && (
        <IcPinMenuIcon
          className={styles.pinMenuIcon}
          onClick={presenter.goToAllPins}
        />
      )}
    </div>
  );
});
